var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useContext } from 'react';
import { useActiveLang, useAppState, useEnv, useSite } from "@shapeable/ui";
import { omit, pickBy, reduce } from 'lodash';
import { chatValueSerialize, ginni } from '@shapeable/utils';
import { useGptStreamState } from './use-gpt-stream-state';
import { GptContext } from '../context/gpt-context';
export var useGpt = function (args) {
  var _a, _b;
  var context = useContext(GptContext);
  var decoder = new TextDecoder();
  var entity = args.entity;
  var entitySid = entity ? "".concat(entity.__type, ":").concat(entity.slug) : 'gpt:global';
  var _c = __read(useAppState(), 2),
    appState = _c[0],
    setAppState = _c[1];
  var activeLang = useActiveLang();
  var usePersonalisation = context.usePersonalisation;
  var env = useEnv();
  var _d = __read(useGptStreamState(), 2),
    gptStreamState = _d[0],
    setGptStreamState = _d[1];
  var controlTypeField = entity ? 'controlTypeContextual' : 'controlType';
  var fallbackControlTypeField = entity ? 'controlType' : 'controlTypeContextual';
  var defaultValueField = entity ? 'defaultValueContextual' : 'defaultValue';
  var defaultValueFallbackField = entity ? 'defaultValue' : 'defaultValueContextual';
  var defaultVariables =
  // Dictionary<ChatMessageValue> = 
  function (vars) {
    return pickBy(reduce(vars, function (acc, variable) {
      var _a;
      var _b;
      var controlType = ((_b = variable[controlTypeField] || variable[fallbackControlTypeField]) === null || _b === void 0 ? void 0 : _b.slug) || 'text';
      var value = variable[defaultValueField] || variable[defaultValueFallbackField] || null;
      if (controlType === 'entity-select-current-entity-selected' && entity) {
        value = entity;
      }
      return __assign(__assign({}, acc), (_a = {}, _a[variable.name] = value, _a));
    }, {}));
  };
  var site = useSite();
  var questionTemplate = site.gptQuestionTemplate;
  var defaultState = {
    isResponseLoading: false,
    variableValues: questionTemplate ? defaultVariables(questionTemplate.variables) : {},
    messages: [],
    language: activeLang,
    activeTemplate: questionTemplate
  };
  var viewState = __assign(__assign({}, defaultState), ((_a = appState.gpt) === null || _a === void 0 ? void 0 : _a[entitySid]) || {});
  var deriveGptViewState = function (prevState, patch, merge) {
    if (merge === void 0) {
      merge = true;
    }
    var newState = __assign(__assign(__assign({}, prevState), patch), {
      variableValues: merge ? __assign(__assign({}, (prevState === null || prevState === void 0 ? void 0 : prevState.variableValues) || {}), patch.variableValues) : patch.variableValues || prevState.variableValues || {},
      messages: merge ? __spreadArray(__spreadArray([], __read((prevState === null || prevState === void 0 ? void 0 : prevState.messages) || []), false), __read(patch.messages || []), false) : patch.messages || prevState.messages || []
    });
    return newState;
  };
  var patchViewState = function (patch, merge) {
    if (merge === void 0) {
      merge = true;
    }
    setAppState(function (prevState) {
      var _a;
      var _b;
      var prevViewState = ((_b = prevState.gpt) === null || _b === void 0 ? void 0 : _b[entitySid]) || {};
      var newState = {
        gpt: __assign(__assign({}, prevState.gpt || {}), (_a = {}, _a[entitySid] = deriveGptViewState(prevViewState, patch, merge), _a))
      };
      return newState;
    });
  };
  var patchVariables = function (patch) {
    var viewStatePatch = {
      variableValues: __assign(__assign({}, viewState.variableValues), patch)
    };
    patchViewState(viewStatePatch);
  };
  var activeTemplate = viewState.activeTemplate,
    activeLanguage = viewState.language,
    messages = viewState.messages,
    variableValues = viewState.variableValues,
    isResponseLoading = viewState.isResponseLoading;
  // ---- Submit question action ---->
  var readStream = function (args) {
    return __awaiter(void 0, void 0, void 0, function () {
      var state, onComplete, isSourcesRetrieved, attempt, _a, partialSources, reader, done, value, err_1, chunk, sources, newState, newState;
      var _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            state = args.state, onComplete = args.onComplete, isSourcesRetrieved = args.isSourcesRetrieved, attempt = args.attempt, _a = args.partialSources, partialSources = _a === void 0 ? '' : _a;
            reader = viewState.reader;
            _c.label = 1;
          case 1:
            _c.trys.push([1, 3,, 4]);
            return [4 /*yield*/, reader.read()];
          case 2:
            _b = _c.sent(), done = _b.done, value = _b.value;
            return [3 /*break*/, 4];
          case 3:
            err_1 = _c.sent();
            if (err_1.name === 'AbortError') {
              // Stream was cancelled
              ginni.always.log('Stream was cancelled');
            } else {
              // Handle other errors
              ginni.always.error('Error reading stream:', err_1);
            }
            return [3 /*break*/, 4];
          case 4:
            if (done) {
              if (onComplete) {
                onComplete({
                  answer: state.answer,
                  sources: state.sources
                });
              }
              // Here we should reset the state so it is no longer displayed.
              // The assumption is that the UI will use this state hook to display the answer AS IT STREAMS
              // but once finished, the answer will be pushed onto a message history stack and displayed there instead.
              // These are separate hooks for performance reasons - we need this streaming hook to be as fast as possible 
              return [2 /*return*/];
            }
            chunk = decoder.decode(value, {
              stream: true
            });
            ginni.info("Stream Chunk:", chunk);
            if (!isSourcesRetrieved) {
              // Remove the 'data: ' prefix to isolate the JSON string
              // const jsonPart = chunk.split("data: ")[1];
              // Parse the JSON string to an object
              try {
                sources = JSON.parse(partialSources + chunk);
                newState = __assign(__assign({}, state), {
                  sources: sources,
                  isStreaming: true
                });
                ginni.info("Sources:", sources);
                ginni.info("New State:", newState);
                setGptStreamState(newState);
                readStream({
                  state: newState,
                  onComplete: onComplete,
                  attempt: 0,
                  isSourcesRetrieved: true,
                  partialSources: ''
                });
              } catch (error) {
                if (attempt < 10) {
                  ginni.info("Partial JSON, fetching next chunk. Attempt:", attempt + 1);
                  readStream({
                    state: state,
                    onComplete: onComplete,
                    isSourcesRetrieved: false,
                    attempt: attempt + 1,
                    partialSources: partialSources + chunk
                  });
                } else {
                  ginni.always.error("Error parsing JSON", error);
                  ginni.always.info("Chunk", chunk);
                }
              }
            } else {
              newState = __assign(__assign({}, state), {
                isStreaming: true,
                answer: (state.answer || '') + chunk
              });
              // once there is a chunk to display, hide the loader
              if (chunk.length > 0) {
                patchViewState({
                  isResponseLoading: false
                });
              }
              setGptStreamState(newState);
              readStream({
                state: newState,
                onComplete: onComplete,
                isSourcesRetrieved: true,
                partialSources: partialSources
              });
            }
            return [2 /*return*/];
        }
      });
    });
  };
  var sendRequest = function (args) {
    return __awaiter(void 0, void 0, void 0, function () {
      var myHeaders, fetchConfig, response, reader, error_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            fetchConfig = {
              method: "POST",
              body: JSON.stringify(omit(args, 'onComplete')),
              responseType: "stream",
              maxBodyLength: Infinity,
              headers: myHeaders
            };
            return [4 /*yield*/, fetch(env.GPT_SERVER, fetchConfig)];
          case 1:
            response = _a.sent();
            if (!response.ok || !response.body) {
              throw response.statusText;
            }
            if (response.ok) {
              reader = response.body.getReader();
              // we need a reference to the reader to be able to cancel it
              patchViewState({
                reader: reader
              });
            }
            return [3 /*break*/, 3];
          case 2:
            error_1 = _a.sent();
            // Handle errors
            ginni.always.error("Error sending request", error_1);
            patchViewState({
              reader: null,
              isCancelled: false,
              isResponseLoading: false,
              activePrompt: null
            });
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  };
  var onComplete = function (args) {
    /* @ts-ignore */
    var cancelled = viewState.reader.__cancelled;
    var _a = viewState.messages,
      messages = _a === void 0 ? [] : _a,
      _b = viewState.language,
      language = _b === void 0 ? activeLang : _b;
    var newMessages = [];
    if (args.answer) {
      var gptMessage = {
        id: "message-".concat(messages.length + 1),
        showControls: true,
        response: "".concat(args.answer).concat(cancelled ? '... (cancelled)' : ''),
        language: language,
        responseSources: args.sources || [],
        prompt: {
          template: viewState.activeTemplate,
          variables: viewState.variableValues
        }
      };
      ginni.info("GPT Final Message:", gptMessage);
      newMessages.push(gptMessage);
      var resetVariableValues = viewState.activeTemplate && defaultVariables(viewState.activeTemplate.variables);
      patchViewState({
        reader: null,
        isSubmitted: false,
        isCancelled: false,
        isResponseLoading: false,
        activePrompt: null,
        variableValues: resetVariableValues || {},
        messages: newMessages
      });
    } else {
      patchViewState({
        reader: null,
        isSubmitted: false,
        isCancelled: false,
        isResponseLoading: false,
        activePrompt: null
      });
    }
    ginni.groupEnd();
    setGptStreamState({
      answer: '',
      sources: [],
      isStreaming: false
    });
  };
  var submitForm = function () {
    var args_1 = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args_1[_i] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([], __read(args_1), false), void 0, function (args) {
      var variableValues;
      if (args === void 0) {
        args = {};
      }
      return __generator(this, function (_a) {
        ginni.group("GPT Request");
        if (!activeTemplate) {
          throw new Error("Cannot submit query, as there is no active GPT template");
        }
        variableValues = __assign(__assign({}, viewState.variableValues), args.values || {});
        ginni.info("Prompt Template:", viewState.activeTemplate);
        ginni.info("Variable Values:", variableValues);
        patchViewState({
          isSubmitted: true,
          isResponseLoading: true,
          variableValues: variableValues,
          activePrompt: {
            template: viewState.activeTemplate,
            variables: variableValues
          }
        });
        return [2 /*return*/];
      });
    });
  };
  var selectTemplate = React.useCallback(function (args) {
    if (args === void 0) {
      args = {};
    }
    var entity = args.entity;
    var variableValues = defaultVariables(entity.variables);
    patchViewState({
      activeTemplate: entity,
      variableValues: variableValues
    }, false);
  }, [viewState]);
  var cancelStream = function () {
    // we patch "isCancelled" to tell React we want to cancel this. Then the effect below picks this up
    // this allows the callback processing the reader stream to actually pick up the state properly
    patchViewState({
      isCancelled: true
    });
  };
  React.useEffect(function () {
    if (viewState.isSubmitted) {
      var requestArgs = {
        promptTemplateId: activeTemplate.id,
        inputVars: __spreadArray([
        // language is built-in
        {
          name: "language",
          value: activeLanguage === null || activeLanguage === void 0 ? void 0 : activeLanguage.name
        }], __read(activeTemplate.variables.map(function (variable) {
          return {
            name: variable.name,
            value: chatValueSerialize(variableValues[variable.name]),
            useVectorStore: variable.useVectorStore
          };
        })), false)
      };
      ginni.info("Request Args:", requestArgs);
      sendRequest(__assign(__assign({}, requestArgs), {
        onComplete: onComplete
      }));
    }
  }, [viewState.isSubmitted]);
  // stream effect listens for a reader to be setup, and then kicks off the stream read
  // this allows us to ensure that stale state is not used in the stream read callbacks
  React.useEffect(function () {
    if (viewState.reader) {
      // kick off the read
      ginni.verbose.log("Starting read stream", gptStreamState);
      readStream({
        state: gptStreamState,
        onComplete: onComplete,
        isSourcesRetrieved: false,
        partialSources: '',
        attempt: 0
      });
    }
  }, [viewState.reader]);
  React.useEffect(function () {
    if (viewState.isCancelled && viewState.reader) {
      // using React state to cancel this reader always resulted in stale state, so we hack  
      // a property directly on the reader, hence the ts-ignore below
      /* @ts-ignore */
      viewState.reader.__cancelled = true;
      viewState.reader.cancel();
    }
  }, [viewState.isCancelled, viewState.reader]);
  return {
    showAutoPrompts: (activeTemplate === null || activeTemplate === void 0 ? void 0 : activeTemplate.id) === ((_b = site.gptQuestionTemplate) === null || _b === void 0 ? void 0 : _b.id),
    selectTemplate: selectTemplate,
    usePersonalisation: usePersonalisation,
    activeLanguage: activeLanguage,
    activeTemplate: activeTemplate,
    activePrompt: viewState.activePrompt,
    patchViewState: patchViewState,
    patchVariables: patchVariables,
    submitForm: submitForm,
    languages: site.gptLanguages,
    messages: messages,
    variableValues: variableValues,
    isResponseLoading: isResponseLoading,
    cancelStream: cancelStream
  };
};